import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import {MissionCard as MissionCardModel} from "../../models/secondary-nav"
import connect from "./connect"

export type DefaultTemplatePropType = {
    title: string
    imageUrl: string
}

type MissionCardProps = MissionCardModel & {
    department: string
    target: string | null
    url: string
    rememberSelectedDepartment: boolean
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const MissionCard: React.FC<MissionCardProps> = memo(
    ({imageUrl, target, title, department, url, rememberSelectedDepartment, templating}) => {
        const TemplatedMissionCard = useTemplatedComponent(templating, MANIFEST)

        return (
            <Suspense>
                <TemplatedMissionCard
                    imageUrl={imageUrl}
                    target={target}
                    title={title}
                    department={department}
                    url={url}
                    rememberSelectedDepartment={rememberSelectedDepartment}
                    data-testid="header-mission-card"
                />
            </Suspense>
        )
    },
)
MissionCard.displayName = "MissionCard"

export default connect(MissionCard)
